/**
 * Syncs the PDP price display with the purchase option selected in the
 * Appstle subscription widget (app block). Appstle's own price sync only
 * targets Dawn's default `.price` markup, so the theme's
 * `.wonderly-product-price__primary` would otherwise keep showing the
 * one-time price after a plan is selected.
 *
 * The formatted amount is copied from the checked option row, so plan
 * discounts and currency conversion (Transcy) come along for free.
 * Unit-priced Grocerist products are skipped — their primary line is
 * $/unit (see data-wonderly-unit-priced in wonderly-product-price.liquid).
 */
(() => {
  const priceTarget = () => {
    const wrapper = document.querySelector(
      '.wonderly-pdp__price .wonderly-product-price:not([data-wonderly-unit-priced])'
    );
    return wrapper ? wrapper.querySelector('.wonderly-product-price__primary') : null;
  };

  const syncPrice = () => {
    const target = priceTarget();
    if (!target) return;
    const checked = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    if (!checked) return;
    const option = checked.closest('.appstle_subscription_wrapper_option');
    const amount = option && option.querySelector('.appstle_subscription_amount');
    const text = amount ? amount.textContent.trim() : '';
    if (text && /\d/.test(text) && target.textContent.trim() !== text) {
      target.textContent = text;
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches) return;
    if (event.target.matches('.appstle_sub_widget input[name="selling_plan"], .appstle_sub_widget select')) {
      syncPrice();
    }
  });

  // Appstle builds and rebuilds the widget asynchronously (initial paint,
  // variant changes) — watch its app block and re-apply after each render.
  const observeWidget = () => {
    const block = document.querySelector('[id*="appstle_subscription_product_page_widget"]');
    if (!block) return false;
    new MutationObserver(syncPrice).observe(block, { childList: true, subtree: true, characterData: true });
    syncPrice();
    return true;
  };

  if (!observeWidget()) {
    document.addEventListener('DOMContentLoaded', observeWidget, { once: true });
  }

  // Dawn re-renders #price-<section> with the one-time price on variant
  // change; re-apply the selected plan's price after it settles.
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncPrice, 0));
  }
})();
